import { c as _c } from "react/compiler-runtime";
import React from "react";
export default function Authors(props) {
  const $ = _c(2);
  const {
    embedCode
  } = props;
  let t0;
  if ($[0] !== embedCode) {
    t0 = <div className="libsyn-embed-container"><iframe height="90" scrolling="no" src={embedCode} width="100%" /></div>;
    $[0] = embedCode;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}